import React from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '../../../store';
import { decrement, increment, tuttorialClose } from '../../../store/features/moments/momentsSlice';

interface ButtonDotProps {
    description: string;
}

const ButtonDot = ({ description }: ButtonDotProps) => {
    const { tuttorialIndex, eventList } = useAppSelector(state => state.moments);
    const { words } = useAppSelector(state => state.localization);
    const dispatch = useDispatch();
    return (
        <>
            <div className="button-dot">
                <a onClick={() => dispatch(tuttorialClose())} className="close-icon" href="#!">
                    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M17.4998 32.0834C25.554 32.0834 32.0832 25.5542 32.0832 17.5001C32.0832 9.44593 25.554 2.91675 17.4998 2.91675C9.44568 2.91675 2.9165 9.44593 2.9165 17.5001C2.9165 25.5542 9.44568 32.0834 17.4998 32.0834Z"
                            stroke="#6C6C7D"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M21.875 13.125L13.125 21.875" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.125 13.125L21.875 21.875" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </a>
                <div className="c-item-01">
                    <p className="c-item-01-A">{description}</p>
                </div>
                <div className="c-item-02">
                    <>
                        {eventList?.items?.length === 0 ? (
                            tuttorialIndex > 3 && (
                                <button onClick={() => dispatch(decrement())} className="c-item-02-A">
                                    {words && words['WEB.before']}
                                </button>
                            )
                        ) : tuttorialIndex === 2 ? null : (
                            <button onClick={() => dispatch(decrement())} className="c-item-02-A">
                                {words && words['WEB.before']}
                            </button>
                        )}
                    </>
                    {tuttorialIndex === 6 ? (
                        <button onClick={() => dispatch(tuttorialClose())} className="c-item-02-B">
                            {words && words['WEB.done']}
                        </button>
                    ) : (
                        <button onClick={() => dispatch(increment(1))} className="c-item-02-B">
                            {words && words['WEB.next']}
                        </button>
                    )}
                </div>
                <div className="c-item-03">
                    {eventList?.items?.length === 0 ? '' : <div className={tuttorialIndex === 2 ? 'dot active' : 'dot'}></div>}
                    <div className={tuttorialIndex === 3 ? 'dot active' : 'dot'}></div>
                    <div className={tuttorialIndex === 4 ? 'dot active' : 'dot'}></div>
                    <div className={tuttorialIndex === 5 ? 'dot active' : 'dot'}></div>
                    <div className={tuttorialIndex === 6 ? 'dot active' : 'dot'}></div>
                </div>
            </div>
        </>
    );
};

export default ButtonDot;
